export default "__VITE_PUBLIC_ASSET__917a299a__"